import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CommercialRealEstateType } from '../../@types/commercialRealEstateType'
import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import { Button } from '../../components/styled/Button/Button'
import { updateCommercialRealEstateType } from '../../store/lead/leadSlice'
import { useReportViewEvent } from '../../hooks'
import { Progress } from '../../@types/progress'
import { reportTrackingEvent } from '../../tracking/thunks'
import { CommercialRealEstateTypeIcon } from '../../components/icons/StepIcons/CommercialRealEstateTypeIcon'
import { IntegrationType } from '../../@types/config'
import { ReduxState } from '../../store/reducers'

interface CommercialRealEstateTypeStepProps {
  goToNextStep: () => unknown
  goToPreviousStep: () => unknown
  progress: Progress
  displayBack: boolean
}

const commercialRealEstateTypeButtons = {
  [CommercialRealEstateType.OFFICE]: 'Büro oder Praxis',
  [CommercialRealEstateType.HALL]: 'Halle oder Produktion',
  [CommercialRealEstateType.RETAIL]: 'Einzelhandel',
  [CommercialRealEstateType.GASTRONOMY]: 'Gastronomie oder Hotel',
  [CommercialRealEstateType.MISCELLANEOUS]: 'Sonstiges',
}

export const headline = 'Um welches Gewerbe handelt es sich?'

export const CommercialRealEstateTypeStep: FC<CommercialRealEstateTypeStepProps> = (props) => {
  useReportViewEvent({ pageTitle: 'realestatesubtype' })
  const { theme, integrationType } = useSelector((state: ReduxState) => state.config)
  const isIv24Integration = integrationType === IntegrationType.IMMOVERKAUF24
  const buttonColor = isIv24Integration ? '#FFFFFF' : theme.text

  const dispatch = useDispatch()

  const goToNextStep = (commercialRealEstateType: CommercialRealEstateType) => {
    dispatch(updateCommercialRealEstateType(commercialRealEstateType))

    dispatch(
      reportTrackingEvent({
        pageTitle: 'realestatesubtype',
        label: 'realestatesubtype_submit',
        inputValue: commercialRealEstateType,
        eventName: 'lead_input',
        customDimensions: {
          ga_cd_lead_engine_input_value: commercialRealEstateType,
        },
      })
    )
    props.goToNextStep()
  }

  return (
    <StepTemplate
      headline={headline}
      progress={props.progress}
      displayNext={false}
      icon={<CommercialRealEstateTypeIcon />}
      displayBack={props.displayBack}
      goToPreviousStep={props.goToPreviousStep}
      backgroundColor={theme.background}
      textColor={theme.text}
    >
      {Object.entries(commercialRealEstateTypeButtons).map(
        ([commercialRealEstateType, commercialRealEstateTypeLabel]) => (
          <Button
            key={commercialRealEstateType}
            onClick={() => goToNextStep(commercialRealEstateType as CommercialRealEstateType)}
            text={commercialRealEstateTypeLabel}
            className='margin-right-l margin-bottom-xl'
            dataTesting={`option-${commercialRealEstateType}`}
            backgroundColor={`${
              isIv24Integration ? theme?.secondary : theme.background !== `` ? theme.background : null
            }`}
            color={buttonColor}
            borderColor={theme.secondary}
          />
        )
      )}
      <div />
    </StepTemplate>
  )
}

export default CommercialRealEstateTypeStep
